import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const BuildIdaasNeed = () => {
  const { t } = useTranslation();
  return (
    <div className="build-idaas-need">
      <section>
        <div className="inner">
          <div>
            <Title title={t("solution.buildIdaas.need.title")}>{t("solution.buildIdaas.need.subtitle")}</Title>
            <div className="difficlty-block" style={{ marginBottom: 60 }}>
              <div className="img-warp">
                <img
                  src="//files.authing.co/authing-website/solution-buildIdaas-difficlty.svg"
                  alt="authing idaas need"
                  width="500"
                />
              </div>
              <div className="text-warp">
                {/* <p>{t("solution.buildIdaas.need.descript1")}</p> */}
                <div className="title">{t("solution.buildIdaas.need.difficltyTitle")}</div>
                <p>{t("solution.buildIdaas.need.descript2")}</p>
                <p>{t("solution.buildIdaas.need.descript3")}</p>
              </div>
            </div>
            <div className="method-block">
              <div className="text-warp" style={{ width: 500 }}>
                <div className="title">{t("solution.buildIdaas.need.methodTitle")}</div>
                <p>{t("solution.buildIdaas.need.descript4")}</p>
              </div>
              <div className="img-warp" style={{ marginRight: 60, marginTop: -18 }}>
                <img
                  src="//files.authing.co/authing-website/solution-buildIdaas-method.svg"
                  alt="authing idaas method"
                />
              </div>
            </div>
            <div className="build-idaas-need-descript">
              <p>{t("solution.buildIdaas.need.descript5")}</p>
              <p>{t("solution.buildIdaas.need.descript6")}</p>
              <p>{t("solution.buildIdaas.need.descript7")}</p>
            </div>
          </div>
          <div>
            <Title title={t("solution.buildIdaas.need.secondTitle")} size="h2">
              {t("solution.buildIdaas.need.secondSubtitle")}
            </Title>
            <div className="proportion-block">
              <div className="warp-img">
                <img
                  src="//files.authing.co/authing-website/solution-buildIdaas-proportion.png"
                  alt="authing idaas need"
                />
              </div>
              <div className="descript-warp">
                <div style={{ marginBottom: 16 }}>{t("solution.buildIdaas.need.secondDescript")}</div>
                <div>{t("solution.buildIdaas.need.secondDescript2")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
